"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _constants = require("./constants");

/**
 * Updates the stored selected theme.
 * @param {string}    themeName       The theme name.
 * @param {function}  refreshCallback Function that can be used to trigger a refresh of the page with the new theme.
 * @param {object}    themeRegistry   The optional theme registry for getting the theme object
 */
var setSelectedTheme = function setSelectedTheme(themeName, refreshCallback, themeRegistry) {
  if (window && window.sessionStorage) {
    var themes = themeRegistry || JSON.parse(window.sessionStorage.getItem(_constants.CX_THEMES));
    var theme = themes ? themes[themeName] : {};
    window.sessionStorage.setItem(_constants.CX_SELECTED_THEME, JSON.stringify(theme));

    if (refreshCallback) {
      refreshCallback(themeName);
    }
  }
};

var _default = setSelectedTheme;
exports.default = _default;